<head>

<script src="https://unpkg.com/vue"></script>
<script src="https://unpkg.com/vue-cal"></script>
<link href="https://unpkg.com/vue-cal/dist/vuecal.css" rel="stylesheet">
</head>
<template>
  <a-card title="Lista de Setores">
    <div class="row" style="margin-bottom: 1%">
      <div class="col-md-3">
        <label for="nome">Descrição</label>
        <div class="input-group input-focus">
          <input type="text" class="form-control form-input-component" v-model="consulta.nome" ref="nome" />
        </div>
      </div>
      <div class="col-md-6">
        <label for="nome">Unidade de Atendimento</label>
        <select v-model="consulta.unidadeAtendimento" class="ant-input ant-input-lg" style="margin: 0; height: 38px !important">
          <option :value="undefined"></option>
          <option v-for="item in unidadesAtendimento" :key="item.id" :value="item">
            {{ item.descricao }}
            <!-- ou o campo que representa o texto -->
          </option>
        </select>
      </div>
      <div class="col-md-3">
        <label for="cpf">Status</label>

        <div class="input-group input-focus">
          <select v-model="consulta.situacao" class="ant-input ant-input-lg" style="margin: 0; height: 38px !important">
            <option value="TODOS">Todos</option>
            <option value="ATIVO">Ativo</option>
            <option value="INATIVO">Inativo</option>
          </select>
        </div>
      </div>
    </div>
    <a-divider type="horizontal" />
    <div class="row">
      <div class="col-md-4">
        <button @click="pesquisar()" class="btn btn-primary" type="button"><i class="fa fa-search"> </i> Pesquisar</button>
        <button type="button" style="margin-left: 4px" class="btn btn-primary" @click="criarNova"><i class="fa fa-plus"> </i> Criar novo</button>
      </div>
    </div>
  </a-card>
  <br />
  <a-card>
    <a-table :dataSource="lista" :columns="columns" :pagination="paginationConfig">
      <template #situacao="{ record }">
        <a-switch :checked="record.situacao === 'ATIVO'" @change="toggleSituacao(record)" />
      </template>
      <template #prazo="{ record }">
        {{ record.prazo + ' meses' }}
      </template>
      <template #action="{ record }">
        <a @click="visualizar(record)">
          <i class="fas fa-eye icon-trash"></i>
        </a>
        &nbsp;&nbsp;
        <a title="Excluir" @click="excluir(record)"><i class="fas fa-trash icon-trash"></i></a>
        &nbsp;&nbsp;
        <a title="Editar" @click="editar(record)"><i class="fas fa-edit icon-edit"></i></a>
      </template>
    </a-table>
  </a-card>
  <Dialog
    header="Detalhes do Setor"
    v-model:visible="showDialog"
    style="
       {
        backgroundcolor: #dcdeff;
      }
    "
    id="showDialog"
  >
    <div class="row">
      <div><label style="margin-left: 1px; font-weight: bold">Setor: </label> {{ this.objetoSelecionado.nome }}</div>
      <div><label style="margin-left: 1px; font-weight: bold">Unidade Atendimento: </label> {{ this.objetoSelecionado.unidadeAtendimento.descricao }}</div>
      <div><label style="margin-left: 1px; font-weight: bold">Status: </label> {{ this.objetoSelecionado.situacao }}</div>
    </div>
    <a-divider type="horizontal" />
  </Dialog>
</template>

<script>
import { openNotification, typesNotification } from '@/utils/notifications';
import { deleteById, getLista, create } from '@/components/service/setorService';
import { getUnidadeAtendimento } from '@/config/servicos-utils';

export default {
  name: 'PageListarSetor',
  data() {
    return {
      nomePagina: 'Setor',
      consulta: { unidadeAtendimento: undefined, nome: undefined, situacao: 'TODOS' },
      objetoSelecionado: undefined,
      unidadesAtendimento: [],
      lista: [],
      showDialog: false,
      paginationConfig: {
        pageSize: 10, // Define o número de itens por página
        total: 0, // Total de itens no dataSource
      },
      columns: [
        {
          title: 'Descrição',
          dataIndex: 'nome',
          key: 'nome',
          slots: { customRender: 'nome' },
        },

        {
          title: 'Unidade Atendimento',
          dataIndex: 'unidadeAtendimento.descricao',
          key: 'unidadeAtendimento.descricao',
          slots: { customRender: 'unidadeAtendimento.descricao' },
        },

        {
          title: 'Status',
          dataIndex: 'situacao',
          key: 'situacao',
          slots: { customRender: 'situacao' },
        },
        {
          title: 'Ações',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
      columnsTableVisualizacao: [
        {
          title: 'Departamento',
          dataIndex: 'nome',
          key: 'nome',
        },
        {
          title: 'Status',
          dataIndex: 'situacao',
          key: 'situacao',
          slots: { customRender: 'situacao' },
        },
      ],
    };
  },
  methods: {
    excluir(record) {
      deleteById(record.id)
        .then(() => {
          openNotification(typesNotification.success, this.nomePagina + ' excluído com sucesso.');
          this.pesquisar();
        })
        .catch(() => {
          openNotification(typesNotification.error, 'Falha ao excluir ' + this.nomePagina.toLowerCase() + '!');
        });
    },
    editar(record) {
      this.$router.push({ path: '/form-setor', query: { id: record.id } });
    },
    visualizar(record) {
      this.objetoSelecionado = record;
      this.showDialog = true;
    },
    criarNova() {
      this.$router.push('form-setor');
    },
    async toggleSituacao(record) {
      const novoStatus = record.situacao === 'ATIVO' ? 'INATIVO' : 'ATIVO';
      const novoRecord = { ...record, situacao: novoStatus };
      await create(novoRecord);
      this.lista.find((i) => i.id == record.id).situacao = novoStatus;
      openNotification(typesNotification.success, 'Status do ' + this.nomePagina.toLowerCase() + ' alterado com sucesso!');
    },

    async toggleSituacaoSubObjeto(record) {
      const novoStatus = record.situacao === 'ATIVO' ? 'INATIVO' : 'ATIVO';
      this.objetoSelecionado.departamentos.find((i) => i.id == record.id).situacao = novoStatus;
      await create(this.objetoSelecionado);
      openNotification(typesNotification.success, 'Status da ' + this.nomePagina.toLowerCase() + ' alterado com sucesso!');
    },
    async pesquisar() {
      getLista(this.consulta)
        .then((r) => {
          if (r.data.length > 0) {
            this.lista = r.data;
          } else {
            openNotification(typesNotification.info, 'Nenhum registro encontrado para os dados informados na pesquisa!');
            this.lista = r.data;
          }
        })
        .catch(() => {
          openNotification(typesNotification.error, 'Falha ao recuperar a lista de ' + this.nomePagina.toLowerCase() + ' cadastrados!');
        });
    },
    async carregarUnidadesAtendimento() {
      await getUnidadeAtendimento().then((response) => {
        this.unidadesAtendimento = response.data;
      });
    },
  },

  created() {
    this.pesquisar();
    this.carregarUnidadesAtendimento();
  },
};
</script>

<style>
.input-group-text {
  height: 38px;
}

.input-group-prepend {
  cursor: pointer;
  margin-left: 8px !important;
}

.input-group-text:hover {
  background-color: #e0e0e0 !important;
}

.h2 {
  font-size: x-large;
}
</style>
